

































import { Vue, Component, Prop } from 'vue-property-decorator';

import eventBus from '@/utils/eventBus';

import SuccessIcon from '@/components/icons/SuccessSolid.vue';
import ShareCampaign from '@/components/ShareCampaign/ShareCampaign.vue';

import CloseModalIcon from '@/components/icons/CloseModal.vue';
import Picture from '@/components/atoms/Picture/Picture.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';

@Component({
  components: {
    CloseModalIcon,
    Picture,
    FilledButton,
    SuccessIcon,
    ShareCampaign
  }
})
export default class CampaignCreated extends Vue {
  @Prop() alreadyActiveCampaign!: boolean;
  @Prop() shareLink?: string;

  handleClose() {
    eventBus.$emit('closeModal');
  }

  mounted() {
    window.addEventListener('popstate', () => {
      this.handleClose();
    });
  }

  get tPrefix() {
    return 'sellCoins.modals';
  }

  get gaTracking() {
    return {
      eventCategory: 'Sell Coins Campaign | Share campaign (modal)',
      eventAction: 'click'
    };
  }
}
